import { Component, Input, OnInit, ViewChild, inject } from "@angular/core";
import { BaseAuditRenderer } from "@app/view/shared/audits/base/base-audit-renderer";
import { AuditService } from "@app/services/http/audit.service";
import { GridComponent } from "@app/view/shared/base-pages/base-data-table-page/grid.component";
import { GridComponent as GridComponent_1 } from "../../base-pages/base-data-table-page/grid.component";

@Component({
  selector: "app-visit-audit-renderer",
  templateUrl: "./visit-audit-renderer.component.html",
  styleUrls: ["./visit-audit-renderer.component.css"],
  imports: [GridComponent_1]
})
export class VisitAuditRendererComponent
  extends BaseAuditRenderer
  implements OnInit
{
  auditService: AuditService;

  @Input() visitId: string;
  @Input() snapshotId: string;
  /*   appointmentStart: Date;
  appointmentEnd: Date;
  visitStatus: VisitStatus; */
  displayedValues = ["appointmentStart", "appointmentEnd", "visitStatus"];
  @ViewChild(GridComponent, { static: true }) auditGrid: GridComponent;

  constructor() {
    const auditService = inject(AuditService);

    super(auditService, "visit");

    this.auditService = auditService;
  }

  ngOnInit() {
    this.getAudit(
      this.snapshotId,
      this.visitId,
      this.auditGrid,
      this.displayedValues
    );
  }
}
